import { StateSchema } from "../../../../app/providers/StoreProvider";

export const getUserData = (state: StateSchema) => state.user
export const getUserIsAuth = (state: StateSchema) => state.user.isAuth
export const getUserInited = (state: StateSchema) => state.user._inited
export const getUserInitLoading = (state: StateSchema) => state.user.isLoading
export const getUserSession = (state: StateSchema) => state.user.user_session_data